/* eslint-disable react/jsx-key */
import React, { useContext } from "react";
import styled, { css } from "styled-components";

import { SectionContainer } from "./common/SectionContainer";
import Title from "./common/Title";
import Subtitle from "./common/Subtitle";
import Paragraph from "./common/Paragraph";

import { COLORS, SIZE } from "./common/constants";

import { DarkModeContext } from "./context/DarkModeContext";

export default function AboutMe() {
  const { isDarkModeOn } = useContext(DarkModeContext);

  return (
    <SectionContainer id="aboutMe">
      <Title title="About Me"></Title>
      <Cards>
        {softskills.map((item) => (
          <Card>
            <ImgContainer isDarkModeOn={isDarkModeOn}>
              <Img>{item.img}</Img>
            </ImgContainer>
            <Subtitle subtitle={item.skill}></Subtitle>
            <Paragraph text={item.description}></Paragraph>
          </Card>
        ))}
      </Cards>
    </SectionContainer>
  );
}

// 🎨 Styled Components
const Cards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${SIZE.medium}) {
    flex-direction: column;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 2em 0 0;
  width: 33.33%;
  @media (max-width: ${SIZE.medium}) {
    padding: 2em 0;
    width: 100%;
  }
`;

const ImgContainer = styled.div`
  width: 3rem;
  height: 3rem;
  border: 1.3px solid ${COLORS.somGreen};
  border-radius: 50%;
  margin-bottom: 1rem;
  box-shadow: 0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.08);
  ${(props) =>
    props.isDarkModeOn &&
    css`
      border: 1px solid ${COLORS.white};
    `}
`;

const Img = styled.div`
  text-align: center;
  font-size: 1.5rem;
  position: relative;
  top: 0.4rem;
`;

const softskills = [
  {
    img: "🙌🏼",
    skill: "Communication Skills",
    description:
      "I can collaborate effectively with designers, developers, and other relevant stakeholders.",
  },
  {
    img: "🔍",
    skill: "Detail-oriented Mindset",
    description:
      "Pixels make perfection - totally agreed. With design background, I am attentive to details to create pixel-perfect UI components.",
  },
  {
    img: "💡",
    skill: "Pro-active Attitude",
    description:
      "I am goal-oriented and enthusiastic about the latest developments in web technologies and ready to go beyond my boundaries.",
  },
];
